import { render, staticRenderFns } from "./group-modal.vue?vue&type=template&id=23dd1d35&scoped=true&"
import script from "./group-modal.vue?vue&type=script&lang=js&"
export * from "./group-modal.vue?vue&type=script&lang=js&"
import style0 from "./group-modal.vue?vue&type=style&index=0&id=23dd1d35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd1d35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23dd1d35')) {
      api.createRecord('23dd1d35', component.options)
    } else {
      api.reload('23dd1d35', component.options)
    }
    module.hot.accept("./group-modal.vue?vue&type=template&id=23dd1d35&scoped=true&", function () {
      api.rerender('23dd1d35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/load-types/group-modal.vue"
export default component.exports